import axios from 'axios'
import toast from '@/component/uiToast/index'
import { getQueryVariable, page500 } from '../util/const'
import { fliterErr500 } from '@/axios/fliters'
import store from '@/store'
import i18n from '@/locale/i18n'

let bossToken, authorization;

// 如果url中带有这些信息，直接读取.在任何页面刷新都能读取
(bossToken = getQueryVariable('bossToken')) && setBossToken(bossToken);
(authorization = getQueryVariable('token')) && setAuthorization(authorization)

function setBossToken (newValue) {
  bossToken = newValue
  // 这里设置的登录后所有接口都会带上这个header，如果值错误就算此接口不需要此header也会报错
  // 如果对接口区分是否要带header是一个比较大的工作量
  axios.defaults.headers.common['BossToken'] = bossToken
}

function getBossToken () {
  return bossToken
}

function clearBossToken () {
  delete axios.defaults.headers.common['BossToken']
}

function setAuthorization (newValue) {
  authorization = 'Bearer ' + newValue
  axios.defaults.headers.common['Authorization'] = authorization
}

function clearAuthorization () {
  delete axios.defaults.headers.common['Authorization']
}

function getAuthorization () {
  return authorization
}

function setHeader (obj) {
  for (let key in obj) {
    axios.defaults.headers.common[key] = obj[key]
  }
}

function getLang () {
  let lang = window.localStorage.getItem('lang')
  if (lang === 'tc') {
    return 'zh-TW'
  }
  if (lang === 'sc') {
    return 'zh-CN'
  }
  if (lang === 'en') {
    return 'en-US'
  }
}
function getsmsLang () {
  let lang = window.localStorage.getItem('lang')
  if (lang === 'tc') {
    return 'zh_tw'
  }
  if (lang === 'sc') {
    return 'zh_cn'
  }
  if (lang === 'en') {
    return 'en_us'
  }
}

function responseTake (res) {
  try {
    if (res.data.header.resultCode !== 0) {
      // 网络错误页面
      throw new Error(JSON.stringify({ type: 1 }))
    }
  } catch (err) {
    let obj = JSON.parse(err.message)
    if (obj.type === 1) {
      console.log('网络错误: ' + res.config.url)
      page500(fliterErr500, res.config.url)
    }
  }
}

function responseCatch (err) {
  switch (err.response.status) {
    case 401:
      toast({ msg: '请求错误:401 授权失败' })
      break
    case 404:
      toast({ msg: '404 NOT FOUND' })
      break
    default:
      console.log('请求错误-code:' + err.response.status)
      toast({ msg: '请求错误-code:' + err.response.status })
  }
}

export {
  setBossToken,
  getBossToken,
  clearBossToken,
  setAuthorization,
  getAuthorization,
  clearAuthorization,
  setHeader,
  getLang,
  responseTake,
  responseCatch,
  getsmsLang,
}



// WEBPACK FOOTER //
// ./src/axios/userInfo.js